export default "__VITE_ASSET__DS1d2BKR__"